import { Component, EventEmitter, Inject, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { FeedbackLoginDialogService } from "./parametro-motivo-dialog.service";
import { BeanMonitoria } from 'src/bean/BeanMonitoria';
import { BeanStatusMonitory } from 'src/bean/BeanStatusMonitory';
import { BeanConfiguracao } from 'src/bean/BeanConfiguracao';
import { StatusMonitoryService } from '../conteudo-global/status-monitory.service';


import { MonitoriaComponent } from "../monitoria.component";
import { ConfiguracaoService } from "../../configuracao/configuracao.service";
import { AESEncryptDecryptService } from "../../../AESEncryptDecryptService";
import { BeanParameter } from "src/bean/BeanParameter";
import { BeanMotivo } from "src/bean/BeanMotivo";
import { BeanMonitoryParameter } from "src/bean/BeanMonitoryParameter";
import { MonitoriaService } from "../monitoria.service";
import { BeanParametroXMotivoMoni } from "src/bean/BeanParametroXMotivoMoni";


@Component({
    selector: 'parametroMotivoDialog',
    templateUrl: 'parametro-motivo-dialog.html',
    styleUrls: ['../monitoria.component.css']
  })
  export class ParametroMotivoDialogDialog implements OnInit {

    //isSpinnerAddStatus = false;


    public moniIdCdMonitoria : number;
    public lstCmbBeanMotivo : BeanMotivo[] = [];
    public beanParameter : BeanParameter = new BeanParameter(null,null,null,null,null,null,null,null,null);
    public beanMonitoryParameter : BeanMonitoryParameter[] = [];
    public lstBeanStatusParametroMonitory : BeanParametroXMotivoMoni[] = [];
    public returnBean : BeanMonitoryParameter[];

    public sessionExpired: boolean = false;

    public formMotivo: FormGroup = new FormGroup({
      'motiIdCdMotivo': new FormControl(null, [Validators.required])
   })


   public  formObservacao: FormGroup = new FormGroup({
    'observacao': new FormControl(null, [Validators.required])
   })


    constructor(
      public dialog: MatDialogRef<MonitoriaComponent>,
      private toastr: ToastrService,
      private statusMonitoryService : StatusMonitoryService,
      private router: Router,

      private monitoriaService : MonitoriaService,
      private _AESEncryptDecryptService: AESEncryptDecryptService,

    ) { }


    public setSessionExpired(errorResponse:any) : boolean {

      if(errorResponse.status == 401){

        this.sessionExpired = true;
      }

      return this.sessionExpired;
    }

    public resetSessionExpired(){

      if(this.sessionExpired){

        this.sair();
        this.toastr.warning("Sua sessão expirou, faça o login novamente!");
      }
    }

    ngOnInit(): void {
      this.listarStatusParametroMonitory(this.beanMonitoryParameter[0].pamoIdCdParametroFormulario);


      this.formObservacao.controls['observacao'].setValue(this.beanMonitoryParameter[0].paraDsValue);
    }


    closeDialog() {



      this.dialog.close({
                            returnBean: this.returnBean === undefined ? null : this.returnBean[0],
                            descricao :  this.formObservacao.value.observacao,
                            idPamo : this.beanMonitoryParameter[0].pamoIdCdParametroFormulario

                          });
    }


    vincularMotivoParametro(){

      let beanParametroXMotivoMoni = new BeanParametroXMotivoMoni(null, null,
                                                                  this.beanMonitoryParameter[0].pamoIdCdParametroFormulario,
                                                                  this.formMotivo.value.motiIdCdMotivo,
                                                                  Number(this._AESEncryptDecryptService.decrypt(localStorage.getItem("idUser")).trim()),
                                                                  null, null);

          this.monitoriaService.criarMotiveParameterMonitory(beanParametroXMotivoMoni).subscribe( response => {

          this.listarStatusParametroMonitory(this.beanMonitoryParameter[0].pamoIdCdParametroFormulario);
          this.toastr.success("Vinculado ao cabeçalho com sucesso","Vinculo motivo")

        }, errorResponse => {

          this.setSessionExpired(errorResponse);
        });

    }

    public sair() {

      this.sessionExpired = false;
      localStorage.clear();
      this.router.navigate([''])

    }



    public listarStatusParametroMonitory(idPamo : number){

      this.monitoriaService.listarStatusPorParametroMonitoria(idPamo).then(lstBeanStatusMonitory => {

        this.lstBeanStatusParametroMonitory = lstBeanStatusMonitory;

      }, errorResponse => {

        this.setSessionExpired(errorResponse);

      }).catch((retorno:any) => {

        if(retorno.error.error_description.indexOf("Access token expired")>-1){
            alert("Sessão Expirada");
            this.router.navigate(['']);
          }
      });
    }




    salvarObservacao() {

      let lstParametros :  BeanMonitoryParameter[]=[];

          if(this.formObservacao.value.observacao != ''){
              let beanFormulario :  BeanMonitoryParameter = new BeanMonitoryParameter(this.beanMonitoryParameter[0].pamoIdCdParametroFormulario,
                Number(this.moniIdCdMonitoria),
                Number(this.beanParameter.paraIdCdParametro),
                this.formObservacao.value.observacao,
                null,
                null,
                null);

              lstParametros.push(beanFormulario)




              this.monitoriaService.createUpdateMonitoriaParametros(lstParametros).then(lstBeanStatusParameterMonitory => {

                this.returnBean =  lstBeanStatusParameterMonitory;

              }, errorResponse => {

                this.setSessionExpired(errorResponse);

              }).catch((retorno:any) => {

                if(retorno.error.error_description.indexOf("Access token expired")>-1){
                    alert("Sessão Expirada");
                    this.router.navigate(['']);
                  }
              });


              this.toastr.success("Cabeçalho atualizado com sucesso","Cabeçalho")

          }else{
            this.toastr.error("Erro ao atualizar o Cabeçalho ","Cabeçalho")

          }


    }


  }

  @Component({
    selector: 'prevParametroMotivoDialog',
    templateUrl: 'previa-parametro-motivo-dialog.html',
    styleUrls: ['../monitoria.component.css']
  })
  export class PrevParametroMotivoDialog implements OnInit {

    //isSpinnerAddStatus = false;


    public moniIdCdMonitoria : number;
    public lstCmbBeanMotivo : BeanMotivo[] = [];
    public beanParameter : BeanParameter = new BeanParameter(null,null,null,null,null,null,null,null,null);
    public beanMonitoryParameter : BeanMonitoryParameter[] = [];
    public lstBeanStatusParametroMonitory : BeanParametroXMotivoMoni[] = [];
    public returnBean : BeanMonitoryParameter[];

    public sessionExpired: boolean = false;

    public formMotivo: FormGroup = new FormGroup({
      'motiIdCdMotivo': new FormControl(null, [Validators.required])
   })

    constructor(
      public dialog: MatDialogRef<MonitoriaComponent>,
      private toastr: ToastrService,
      @Inject(MAT_DIALOG_DATA) public data: {
        beanParameter: BeanParameter,
        lstCmbBeanMotivo: BeanMotivo[]
      },
      private router: Router,

      private monitoriaService : MonitoriaService,
      private _AESEncryptDecryptService: AESEncryptDecryptService,

    ) { }


    public setSessionExpired(errorResponse:any) : boolean {

      if(errorResponse.status == 401){

        this.sessionExpired = true;
      }

      return this.sessionExpired;
    }

    public resetSessionExpired(){

      if(this.sessionExpired){

        this.sair();
        this.toastr.warning("Sua sessão expirou, faça o login novamente!");
      }
    }

    ngOnInit(): void {

    }


    closeDialog() {

      this.dialog.close();
    }

    public sair() {

      this.sessionExpired = false;
      localStorage.clear();
      this.router.navigate([''])

    }
  }
